import { forwardRef, useEffect, useState } from "react"
import { videoPlayer } from "../styles"

interface SlidePlayerProps {
  url: string
  playing?: boolean
  onPause?: any
}

export const SlidePlayer = forwardRef((props: SlidePlayerProps, ref: any) => {
  const { url, playing, onPause } = props
  const [frames, setFrames] = useState<any[]>([])
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    // if (url) fetch(url).then(r => console.log(r.headers.get('Content-Type')))
    if (url) fetch(url).then(r => r.blob().then((blob) => blob.arrayBuffer().then((arrayBuffer) => {
      let i = 0, frames = []
      while (i < arrayBuffer.byteLength) {
        const size = new DataView(arrayBuffer.slice(i, i + 4)).getInt32(0, false)
        i += 4
        frames.push(URL.createObjectURL(new Blob([arrayBuffer.slice(i, i + size)], { type: 'image/jpeg' })))
        i += size
      }
      setFrames(frames)
      // ref.current = {seekTo:()=>{},getDuration:()=>1} // заглушка
    })))
  }, [])

  useEffect(() => {
    if (playing && frames.length !== 0) {
      setProgress(0)
      const interval = setInterval(() => {
        if (playing) {
          setProgress((prev) => prev+1)
        } else {
          clearInterval(interval)
        }
      }, 2000)
      return () => {
        clearInterval(interval)
      }
    }
  }, [playing, frames])

  useEffect(() => {
    if (progress === frames.length-1) {
      onPause()
    }
  }, [progress])

  return (
    <img src={frames[progress]} style={{ ...videoPlayer, height: '100%', width: '100%', objectFit: 'contain' }} />
  )
})
